import { BodyExtraSmall } from '@taxbit-private/cosmic'
import { useCosmicLocalizationContext } from '@taxbit-private/cosmic-localization'

import { AirflowDagRunState } from 'api/types/gcDagApiTypes'
import { useFetchGcDagRuns } from 'hooks/data/gc-dags/gcDagHooks'

const GlobalRunStatus = () => {
  const { data: runsData } = useFetchGcDagRuns()
  const { formatDateTime } = useCosmicLocalizationContext()

  const runs = runsData?.dag_runs
  const lastSuccess = runs?.find((e) => e.state === AirflowDagRunState.Success)
  const currentRun = runs?.find((run) => run.state === AirflowDagRunState.Running)
  const label = currentRun ? 'Processing...' : 'Last processed'
  const datetime = lastSuccess?.start_date
  const isProcessing = !!currentRun

  return (
    <BodyExtraSmall colorVariant="secondary">
      {isProcessing
        ? label
        : `${label}: ${formatDateTime({
            date: datetime,
            format: 'DateTime',
          })}`}
    </BodyExtraSmall>
  )
}

export default GlobalRunStatus
